<ng-container *ngIf="!noLabel">
  <div class="label-basic-container" [ngClass]="getLevelClass()">
    <div class="label-basic" [ngClass]="{ 'label-basic--disabled': isDisabled, 'label-basic--readonly': isReadonly }">
      <ng-container *ngIf="additionalDescription; else noDescription">
        <question-text [componentId]="componentId" [inputClass]="inputClass" [styleClass]="questionItem.styleClass">
          <div class="label-basic__text-container">
            <div *ngIf="scrollId" [id]="scrollId"></div>
            <p class="label-basic__text">
              {{ displayText }}
              <ng-container *ngIf="showQuestionLock" class="question_lock--cpds-badge">
                <cpds-badge
                  [style]="'shaded'"
                  [intent]="'neutral'"
                  class="question_lock--cpds-badge"
                  *cpdsTooltip="questionLockToolTip; type: 'description'; position: 'bottom'"
                >
                  <cpds-icon icon="padlock-lock" size="small"></cpds-icon>
                  <label>Locked</label>
                </cpds-badge>
              </ng-container>
              <ng-container *ngIf="questionItem.helpText && !isServer && includeToolTip">
                <tooltip [isDisabled]="isTooltipDisabled" [isReadonly]="isReadonly">
                  <div tip [innerHTML]="questionItem.helpText"></div>
                </tooltip>
              </ng-container>
            </p>

            <p class="label-basic__subtext" [innerHTML]="additionalDescription"></p>
          </div>
        </question-text>
      </ng-container>
      <ng-template #noDescription>
        <question-text
          [componentId]="componentId"
          [inputClass]="inputClass"
          [styleClass]="questionItem.styleClass"
          [displayText]="displayText"
        >
          <div *ngIf="scrollId" [id]="scrollId"></div>
        </question-text>
        <ng-container *ngIf="questionItem.helpText && !isServer && includeToolTip">
          <tooltip [isDisabled]="isTooltipDisabled" [isReadonly]="isReadonly">
            <div tip [innerHTML]="questionItem.helpText"></div>
          </tooltip>
        </ng-container>
      </ng-template>
      <ng-container *ngIf="questionItem.modalType">
        <modal-trigger-button [isDisabled]="isDisabled"></modal-trigger-button>
      </ng-container>
      <div *ngIf="showQuestionLock" class="question_lock--cpds-badge">
        <cpds-badge
          [style]="'shaded'"
          [intent]="'neutral'"
          class="question_lock--cpds-badge"
          *cpdsTooltip="questionLockToolTip; type: 'description'; position: 'bottom'"
        >
          <cpds-icon icon="padlock-lock" size="small"></cpds-icon>
          <label>Locked</label>
        </cpds-badge>
      </div>
    </div>
  </div>
</ng-container>
